import go from 'gojs';
import { formatDate } from 'react-day-picker/moment';
import { updateObject } from "../../storeFunctions";
import { _name, GRAPH_MODE } from '../common/constants';
import { _eventLoggerSend } from '../common/functions';
import { diagram } from '../diagram/initial';
import { _getVisibleNodesData, _getVisibleRelationsData } from '../diagram/visiblityActions';

// KEYS
const actions = {
    BOTTOM_WINDOW: { _name: _name + '_BOTTOM_WINDOW' },
};
actions.BOTTOM_WINDOW = Object.assign(actions.BOTTOM_WINDOW, {
    OPEN: actions.BOTTOM_WINDOW._name + '_OPEN',
    CLOSE: actions.BOTTOM_WINDOW._name + '_CLOSE',
    ACTIVATE_TAB: actions.BOTTOM_WINDOW._name + '_ACTIVATE_TAB',
    CLOSE_TAB: actions.BOTTOM_WINDOW._name + '_CLOSE_TAB',
    MAXIMIZE: actions.BOTTOM_WINDOW._name + '_MAXIMIZE',
    MINIMIZE: actions.BOTTOM_WINDOW._name + '_MINIMIZE',
    NI_UPDATE: actions.BOTTOM_WINDOW._name + '_NI_UPDATE',
    SUBJECT_UPDATE: actions.BOTTOM_WINDOW._name + '_SUBJECT_UPDATE',
    TIMELINE_UPDATE: actions.BOTTOM_WINDOW._name + '_TIMELINE_UPDATE',
    TIMELINE_UPDATE_MARKS: actions.BOTTOM_WINDOW._name + '_TIMELINE_UPDATE_MARKS',
    UPDATE_HEIGHT: actions.BOTTOM_WINDOW._name + '_UPDATE_HEIGHT'
});

// MAP
const actionMap = {
    [`${actions.BOTTOM_WINDOW.OPEN}`]: (state, data) => updateObject(state, { bottomWindow: updateObject(state.bottomWindow, { expanded: true }) }),
    [`${actions.BOTTOM_WINDOW.NI_UPDATE}`]: (state, data) => updateObject(state, { bottomWindow: updateObject(state.bottomWindow, { negInfo: updateObject(state.bottomWindow.negInfo, { data: data }) }) }),
    [`${actions.BOTTOM_WINDOW.SUBJECT_UPDATE}`]: (state, data) => updateObject(state, { bottomWindow: updateObject(state.bottomWindow, { subjects: updateObject(state.bottomWindow.subjects, { data: data }) }) }),
    [`${actions.BOTTOM_WINDOW.TIMELINE_UPDATE}`]: (state, data) => updateObject(state, { bottomWindow: updateObject(state.bottomWindow, { timeline: updateObject(state.bottomWindow.timeline, { data: data }) }) }),
    [`${actions.BOTTOM_WINDOW.TIMELINE_UPDATE_MARKS}`]: (state, data) => {
        let bottom = { ...state.bottomWindow };
        let newData = bottom.timeline.data;
        newData.marks = data;
        bottom.timeline = updateObject(bottom.timeline, { data: newData });
        return updateObject(state, { bottomWindow: bottom });
    },
    [`${actions.BOTTOM_WINDOW.UPDATE_HEIGHT}`]: (state, data) => updateObject(state, { bottomWindow: updateObject(state.bottomWindow, { height: data }) }),
    [`${actions.BOTTOM_WINDOW.CLOSE}`]: (state, data) => {
        let bottom = { ...state.bottomWindow };
        bottom.expanded = false;
        bottom.maximized = false;
        bottom.height = 0;
        bottom.negInfo = updateObject(bottom.negInfo, { isActive: false, isShowed: false });
        bottom.timeline = updateObject(bottom.timeline, { isActive: false, isShowed: false });
        bottom.subjects = updateObject(bottom.subjects, { isActive: false, isShowed: false });
        document.getElementById('diagramPlane').style.height = '100%'
        document.getElementById('bottomContainer').style.height = '0%';
        diagram.nodeDiagram.requestUpdate();
        return updateObject(state, { bottomWindow: bottom });
    },
    [`${actions.BOTTOM_WINDOW.ACTIVATE_TAB}`]: (state, data) => {
        let bottom = { ...state.bottomWindow };

        if (!bottom.negInfo.isShowed && !bottom.timeline.isShowed && !bottom.subjects.isShowed) {
            document.getElementById('diagramPlane').style.height = '65%';
            document.getElementById('bottomContainer').style.height = '35%';
            diagram.nodeDiagram.requestUpdate();
        }

        bottom.expanded = true;
        bottom.negInfo = updateObject(bottom.negInfo, { isActive: data.tab === 'negInfo', isShowed: data.tab === 'negInfo' || bottom.negInfo.isShowed, intialized: Date.now() });
        bottom.timeline = updateObject(bottom.timeline, { isActive: data.tab === 'timeline', isShowed: data.tab === 'timeline' || bottom.timeline.isShowed, intialized: Date.now() });
        bottom.subjects = updateObject(bottom.subjects, { isActive: data.tab === 'subjects', isShowed: data.tab === 'subjects' || bottom.subjects.isShowed, intialized: Date.now() });
        return updateObject(state, { bottomWindow: updateObject(state.bottomWindow, bottom) });
    },
    [`${actions.BOTTOM_WINDOW.CLOSE_TAB}`]: (state, data) => {
        let bottom = { ...state.bottomWindow };
        bottom.negInfo = data.tab === 'negInfo' ? updateObject(bottom.negInfo, { isActive: false, isShowed: false }) : { ...bottom.negInfo };
        bottom.timeline = data.tab === 'timeline' ? updateObject(bottom.timeline, { isActive: false, isShowed: false }) : { ...bottom.timeline };
        bottom.subjects = data.tab === 'subjects' ? updateObject(bottom.subjects, { isActive: false, isShowed: false }) : { ...bottom.subjects };
        bottom.expanded = bottom.negInfo.isShowed || bottom.timeline.isShowed || bottom.subjects.isShowed;
        if (bottom.expanded && !((bottom.negInfo.isActive && bottom.negInfo.isShowed) || (bottom.timeline.isActive && bottom.timeline.isShowed) || (bottom.subjects.isActive && bottom.subjects.isShowed))) {
            let done = false;
            if (!bottom.negInfo.isActive && bottom.negInfo.isShowed && !done) { done = bottom.negInfo.isActive = true; bottom.negInfo.intialized = Date.now(); }
            if (!bottom.timeline.isActive && bottom.timeline.isShowed && !done) { done = bottom.timeline.isActive = true; bottom.timeline.intialized = Date.now(); }
            if (!bottom.subjects.isActive && bottom.subjects.isShowed && !done) { done = bottom.subjects.isActive = true; bottom.subjects.intialized = Date.now(); }
        }
        if (!bottom.expanded) {
            document.getElementById('diagramPlane').style.height = '100%';
            document.getElementById('bottomContainer').style.height = '0%';
            diagram.nodeDiagram.requestUpdate();
        }
        return updateObject(state, { bottomWindow: updateObject(state.bottomWindow, bottom) });
    },
    [`${actions.BOTTOM_WINDOW.MAXIMIZE}`]: (state, data) => {
        document.getElementById('diagramPlane').style.height = '';
        document.getElementById('bottomContainer').style.height = '100%';
        diagram.nodeDiagram.requestUpdate();
        return state;
    },
    [`${actions.BOTTOM_WINDOW.MINIMIZE}`]: (state, data) => {
        document.getElementById('diagramPlane').style.height = '65%';
        document.getElementById('bottomContainer').style.height = '35%';
        diagram.nodeDiagram.requestUpdate();
        return state;
    },
}

// ACTIONS
const chartActions = {
    toggleBottomWindow: (target) => async (dispatch, getState) => {
        var isShowed = (getState().charts.bottomWindow[target] || {}).isShowed;
        _eventLoggerSend('bottomWindow', target + '-' + (isShowed ? 'off' : 'on'));
        dispatch({ type: isShowed ? actions.BOTTOM_WINDOW.CLOSE_TAB : actions.BOTTOM_WINDOW.ACTIVATE_TAB, data: { tab: target } });
    },
    activateBottomWindow: (e, tabName) => async (dispatch, getState) => dispatch({ type: actions.BOTTOM_WINDOW.ACTIVATE_TAB, data: { tab: tabName } }),
    closeBottomTab: (e, tabName) => async (dispatch, getState) => {
        dispatch({ type: actions.BOTTOM_WINDOW.CLOSE_TAB, data: { tab: tabName } });
        e.stopPropagation();
    },
    closeBottomWindow: () => async (dispatch, getState) => dispatch({ type: actions.BOTTOM_WINDOW.CLOSE }),
    maximizeBottomWindow: (e) => async (dispatch, getState) => { _eventLoggerSend('bottomWindow', 'maximize'); dispatch({ type: actions.BOTTOM_WINDOW.MAXIMIZE }) },
    minimizeBottomWindow: (e) => async (dispatch, getState) => { _eventLoggerSend('bottomWindow', 'minimize'); dispatch({ type: actions.BOTTOM_WINDOW.MINIMIZE }) },
    updateBottomWindowHeight: (w, h) => async (dispatch, getState) => {
        dispatch({ type: actions.BOTTOM_WINDOW.UPDATE_HEIGHT, data: h - 38 });
        if (getState().charts.bottomWindow.timeline.isShowed) {
            dispatch({
                type: actions.BOTTOM_WINDOW.TIMELINE_UPDATE_MARKS, data: _calculateTimelineMarks(getState().charts.bottomWindow.timeline.data.maxYear, getState().charts.bottomWindow.timeline.data.minYear)
            });
        }
    },
    selectEntity: (eid, event) => async (dispatch, getState) => {
        if (!event.ctrlKey) { //normal click
            diagram.nodeDiagram.select(diagram.nodeDiagram.findNodeForKey(eid));
        }
        else { // with CTRL modifier
            var selectedNodes = [];
            diagram.nodeDiagram.selection.each(function (n) {
                if (n instanceof go.Node) {
                    selectedNodes.push(n);
                }
            });
            selectedNodes.push(diagram.nodeDiagram.findNodeForKey(eid));
            diagram.nodeDiagram.selectCollection(selectedNodes);
        }
        _focusOnSelectedNode(diagram.nodeDiagram);
    },
}

// FUNCTIONS
function _updateBottomWindow(dispatch) {
    dispatch({ type: actions.BOTTOM_WINDOW.NI_UPDATE, data: _niGetData() });
    dispatch({ type: actions.BOTTOM_WINDOW.SUBJECT_UPDATE, data: _subjGetData() });
    dispatch({ type: actions.BOTTOM_WINDOW.TIMELINE_UPDATE, data: _timelineGetData() });
}


function _niGetData() {
    var data = [];
    var nodes = _getVisibleNodesData();
    var relations = _getVisibleRelationsData();

    nodes.forEach(function (el) {
        if (el.WarningShortcuts == null || el.WarningShortcuts.length === 0) { return; }
        var visibleWarnings = el.WarningShortcuts.filter(function (w) { return w.IsFiltered; });
        if (visibleWarnings.length === 0) { return; }

        var item = { subject: el, warnings: visibleWarnings, link: _niGetRelationToShow(relations.filter(function (it) { return it.ChildID === el.EntityID; })), parent: null };
        if (item.link != null) {
            var parentSelect = nodes.filter(function (nd) { return nd.EntityID === item.link.ParentID });
            item.parent = parentSelect.length === 0 ? null : parentSelect[0];
        }

        data.push(item);
    });

    return data.sort(function (a, b) {
        if (a.subject.Level !== b.subject.Level) {
            return a.subject.Level - b.subject.Level;
        }
        return a.subject.NameNormalized < b.subject.NameNormalized ? -1 : 1;
    });
}

function _niGetRelationToShow(relations) {
    var relationToShow = [];
    if (relations == null || relations === undefined) { return null; }
    relations.filter(function (rr) { return rr.RelationsData != null && rr.RelationsData.length > 0; }).forEach(function (data) { relationToShow.push(_niSelectPreferedRelation(data.RelationsData)); });

    if (relationToShow.length === 0)
        return null;

    if (relationToShow.length === 1)
        return relationToShow[0];

    return _niSelectPreferedRelation(relationToShow);
}

function _niSelectPreferedRelation(data) {
    if (data == null || data === undefined) {
        return null;
    }
    var currentOnly = data.filter(function (e) { return e.EndDate == null || e.EndDate === undefined });
    var historyOnly = data.filter(function (e) { return e.EndDate != null && e.EndDate !== undefined })

    if (currentOnly.length !== 0) {
        currentOnly.sort(function (a, b) { return a.RelationImportanceId < b.RelationImportanceId ? -1 : 1; });
        return currentOnly[0];
    } else {
        var maxEndDate = Math.max.apply(null, historyOnly.map(function (e) { return e.EndDateCompare; }));
        historyOnly = historyOnly.filter(function (e) { return e.EndDateCompare === maxEndDate });
        historyOnly.sort(function (a, b) { return a.RelationImportanceId < b.RelationImportanceId ? -1 : 1; });
        return historyOnly[0];
    }
}

function _subjGetData() {
    var processedLinksId = [];
    var rootNodes = [];
    var rootLevel = (diagram._mode === GRAPH_MODE.merge) ? 1 : 0;

    var nodes = _getVisibleNodesData();
    var relations = _getVisibleRelationsData();
    rootNodes = nodes.filter(function (e) { return e.OriginalLevel === rootLevel });

    var visibleNodes = _setSubjectsTableData(rootNodes, nodes, relations, rootLevel, processedLinksId, null).data;
    var maxLevel = _subjGetHighestLevel(visibleNodes, rootLevel);

    return { nodes: visibleNodes, maxLevel: maxLevel };
}

function _setSubjectsTableData(rootNodes, allNodes, links, currentLevel, processedLinksId, directParent) {
    var nodeResult = {};
    nodeResult.data = [];
    nodeResult.processedLinksId = processedLinksId;
    nodeResult.visitedLinks = []

    rootNodes.forEach(function (rootNode) {
        var rels = links.filter(function (e) { return e.ParentID === rootNode.EntityID; });
        var childIds = rels.map(function (e) { return e.ChildID; });
        var subnodes = allNodes.filter(function (e) { return childIds.includes(e.EntityID) && e.Level > currentLevel; });
        var subject = _subjCreateFromData(rootNode, currentLevel);

        var toParentRelations = links.filter(function (e) { return e.ChildID === rootNode.EntityID && directParent != null && e.ParentID === directParent.EntityID });
        if (toParentRelations.length > 0) {
            for (let j = 0; j < toParentRelations.length; j++) {
                for (let k = 0; k < toParentRelations[j].RelationsData.length; k++) {
                    let tpr = toParentRelations[j].RelationsData[k];
                    subject.Relations.push({
                        LinkGuarantee: tpr.Guaranteed === 0 ? 'unsure' : tpr.Guaranteed === 1 ? 'certain' : tpr.Guaranteed === 2 ? 'lessCertain' : '',
                        FromDate: tpr.StartDate,
                        FromDateFormated: tpr.StartDateFormated,
                        ToDate: tpr.EndDate,
                        ToDateFormated: tpr.EndDateFormated,
                        IsHistorical: tpr.EndDate !== null,
                        Description: tpr.Name,
                        Share: tpr.SharePct !== null ? tpr.SharePct + "%" : "",
                        Direction: tpr.Polarity === -1 ? "→" : tpr.Polarity === 1 ? "←" : "",
                        RelationShortening: tpr.RelationShortening,
                        RelationType: tpr.RelationType,
                        Function: tpr.Function,
                        RootGroupId: tpr.RootGroupId,
                        SourceID: tpr.SourceID
                    });
                }
            }
        }

        if (subnodes.length === 0) {
            nodeResult.data.push(subject);
            return;
        }

        for (let j = 0; j < rels.length; j++) {
            for (let k = 0; k < rels[j].RelationsData.length; k++) {
                processedLinksId.push(rels[j].RelationsData[k].RelationID);
            }
        }

        if (childIds.length > 0) {
            var childData = _setSubjectsTableData(allNodes.filter(function (e) { return childIds.includes(e.EntityID) }), allNodes, links, currentLevel + 1, processedLinksId, rootNode);
            subject.ChildrenNodes = childData.data;
            nodeResult.processedLinksId = childData.processedLinksId;
        }

        nodeResult.processedLinksId = processedLinksId;
        nodeResult.data.push(subject);
    });

    var result = [];

    nodeResult.data.forEach(function (e) {
        var exists = result.filter(function (item) { return e.EntityID === item.EntityID });
        if (exists.length === 0) {
            result.push(e);
        } else {
            e.Relations.forEach(function (ee) {
                exists[0].Relations.push(ee);
            });
        }
    });

    return { data: result };
}

function _subjCreateFromData(data, level) {
    var subject = {
        EntityID: data.EntityID,
        IsExpanded: data.IsExpanded,
        HasChildrenLoaded: data.HasChildrenLoaded,
        Name: data.Name,
        NameNormalized: data.NameNormalized,
        Address: data.FullAddress,
        Warnings: data.WarningShortcuts.filter(function (warning) { return warning.IsFiltered; }),
        EntityType: data.EntityType,
        Level: level,
        Relations: [],
        ChildrenNodes: []
    };


    if (data.Type === "Person") {
        subject.ICORDateOfBirth = data.DateOfBirthOrCreationDate;
        subject.ICORDateOfBirthFormated = data.DateOfBirthOrCreationDateFormated;
    } else if (data.Type === "Company" || data.Type === "Tradesman") {
        subject.ICORDateOfBirth = data.IC;
        subject.ICORDateOfBirthFormated = data.IC;
    }

    return subject;
}

function _subjGetHighestLevel(nodes, level) {
    if (nodes.length === 0) return (level - 1);
    var maxLevel = level;
    nodes.forEach(function (node) {
        var childHighestLevel = maxLevel;
        if (node.IsExpanded) childHighestLevel = _subjGetHighestLevel(node.ChildrenNodes, level + 1);
        if (childHighestLevel > maxLevel) maxLevel = childHighestLevel;
    });
    return maxLevel;
}

function _timelineGetData() {
    var nodes = _getVisibleNodesData();
    var relations = _getVisibleRelationsData();

    var timelineRelations = [];
    var minYear = new Date().getFullYear() + 1;
    relations.forEach(function (relGroup) {
        relGroup.RelationsData.forEach(function (relation) {
            var currYear = new Date(relation.StartDate).getFullYear();
            minYear = currYear < minYear ? currYear : minYear;
        });
    });
    var maxYear = new Date().getFullYear() + 1;
    var vals = maxYear - minYear;


    for (var i = 0; i < relations.length; i++)
        for (var j = 0; j < relations[i].RelationsData.length; j++) {
            var r = relations[i].RelationsData[j];
            if (r.OppositeDirrection) {
                r.childName = _getNodeName(nodes, relations[i].ParentID);
                r.parentName = _getNodeName(nodes, relations[i].ChildID);
            }
            else {
                r.parentName = _getNodeName(nodes, relations[i].ParentID);
                r.childName = _getNodeName(nodes, relations[i].ChildID);
            }
            var percentage = r.SharePct !== null ? '(' + r.SharePct + '%)' : "";
            r.divText = r.RootRelationShortening + ' (' + r.RelationShortening + ') ' + percentage;

            var startDate = new Date(r.StartDate);
            var yearDifference = startDate.getFullYear() - minYear + ((startDate.getMonth() + 1) / 12);
            var oneStep = (1 / vals) * 100;

            r.startOffset = (yearDifference * oneStep);
            if (r.startOffset < 0)
                r.startOffset = 0;

            var endOffset = 100;
            if (r.EndDate != null) {
                var endDate = new Date(r.EndDate);
                var endYearDiff = maxYear - (endDate.getFullYear() + ((endDate.getMonth() + 1) / 12));
                endOffset = 100 - (oneStep * endYearDiff);
                if (endOffset < 0)
                    endOffset = 0;
            }
            r.linkClass = r.State === 0 ? "currentRelation" : "historicalRelation";
            r.linkClass = r.linkClass + " floatingGraphRelation";
            r.finalWidth = (endOffset - r.startOffset) < 1 ? 1 : (endOffset - r.startOffset);

            var dateFrom = r.StartDate ? new Date(r.StartDate) : null;
            r.dateFrom = dateFrom ? formatDate(dateFrom, 'DD.MM.YYYY', 'cs') : '';

            var dateTo = r.EndDate ? new Date(r.EndDate) : null;
            r.dateTo = dateTo ? formatDate(dateTo, 'DD.MM.YYYY', 'cs') : '';

            timelineRelations.push(r);
        }

    timelineRelations.sort(function (a, b) { return new Date(a.StartDate) - new Date(b.StartDate) });

    return { relations: timelineRelations, minYear, maxYear, marks: _calculateTimelineMarks(maxYear, minYear) };
}

function _getNodeName(nodes, entityId) {
    return nodes.filter(function (n) { return n.EntityID === entityId })[0].Name;
}

function _calculateTimelineMarks(maxYear, minYear) {
    var width = document.getElementById('diagramPlane').offsetWidth - 560;
    const minWidth = 25;

    var step = 1;
    if ((maxYear - minYear) * minWidth > width)
        step = Math.ceil((maxYear - minYear) * minWidth / width);
    var marks = {};
    for (var i = minYear; i < maxYear; i += step)
        marks[i] = (i.toString());
    marks[maxYear] = '';
    return marks;
}

function _focusOnSelectedNode(dgrm) {
    var i = 0;
    dgrm.selection.each(function (n) {
        if (n instanceof go.Node) {
            if (i === 0) {
                dgrm.scale = 0.7;
                dgrm.centerRect(n.actualBounds);
                i += 1;
            }
        }
    });
}

export {
    _updateBottomWindow,
    actionMap as bottomWindowActionMap, actions as bottomWindowActions, chartActions as bottomWindowChartActions
};
